import { FadeIn, MaskedLineScroll, Overline } from "@/components/Reveal";
import Frame from "@/components/Frame";

const REASONS = [
  {
    title: "Déplacement gratuit",
    text: "Nous venons constater l'état de votre toiture sans frais, que ce soit pour une fuite, une tuile cassée ou un projet de rénovation.",
  },
  {
    title: "Devis gratuit",
    text: "Un devis clair et détaillé, sans engagement : vous savez exactement ce qui est prévu avant que les travaux ne commencent.",
  },
  {
    title: "Intervention dans tout le Val-de-Marne",
    text: "Basés à Champigny-sur-Marne, nous couvrons l'ensemble du département (94), de Saint-Maur-des-Fossés à Créteil et Vitry-sur-Seine.",
  },
  {
    title: "Entreprise locale",
    text: "Une entreprise de couverture ancrée dans le 94, avec un showroom à Champigny-sur-Marne où vous pouvez venir nous rencontrer.",
  },
  {
    title: "Travail soigné",
    text: "Couverture, zinguerie, étanchéité : chaque détail compte sur une toiture. Nous travaillons proprement et dans les règles du métier.",
  },
  {
    title: "Conseils personnalisés",
    text: "Chaque toit est différent. Nous vous expliquons l'état réel de votre couverture et les solutions adaptées, sans discours commercial.",
  },
  {
    title: "Réparation et rénovation",
    text: "Du dépannage ponctuel à la rénovation complète, nous prenons en charge tous vos travaux de toiture, du diagnostic à la finition.",
  },
  {
    title: "Contact téléphonique direct",
    text: "Pas de plateforme, pas de standard : vous parlez directement à l'entreprise qui interviendra chez vous, au 06 46 30 03 91.",
  },
];

export default function Pourquoi() {
  return (
    <section id="pourquoi" className="bg-midnight text-white py-24 md:py-32 grain relative" data-testid="pourquoi-section">
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-6">
            <Overline dark>À propos — Manifeste</Overline>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
              <MaskedLineScroll>Pourquoi choisir</MaskedLineScroll>
              <MaskedLineScroll delay={0.12}><span className="text-signal">MSC Toitures</span> ?</MaskedLineScroll>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <FadeIn delay={0.2}>
              <Frame
                dark
                label="PHOTO ÉQUIPE / TOITURE"
                ratio="aspect-[16/10]"
                src="/photos/equipe.webp"
                alt="Couvreur MSC Toitures en intervention sur un échafaudage dans le Val-de-Marne"
              />
            </FadeIn>
          </div>
        </div>
        <div className="border-t border-white/10">
          {REASONS.map((r, i) => (
            <FadeIn key={r.title} delay={0.05 * (i % 4)}>
              <div
                className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-b border-white/10 group"
                data-testid={`pourquoi-item-${i}`}
              >
                <div className="md:col-span-2">
                  <span className="font-mono text-sm text-signal tracking-[0.2em]">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-extrabold uppercase tracking-tight text-xl group-hover:text-signal transition-colors duration-300">
                    {r.title}
                  </h3>
                </div>
                <div className="md:col-span-6">
                  <p className="text-sm md:text-base text-white/60 leading-relaxed">{r.text}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
